import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=40c63ada&scoped=true"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"
import style0 from "./Reward.vue?vue&type=style&index=0&id=40c63ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c63ada",
  null
  
)

export default component.exports